// src/app/core/models/connection.models.ts
export enum ConnectionStatus {
  PENDING = 'pending',
  CONNECTED = 'connected',
  DISCONNECTED = 'disconnected',
  ERROR = 'error'
}

export interface Connection {
  id: string;
  owner: string;
  company_id: number;
  phoneNumber: string | null;
  instanceName: string;
  status: ConnectionStatus | string;
  qrCode: string | null;
  receivers: string[];
  groupReceivers: string[];
  createdAt: Date | string;
  updatedAt: Date | string;
  integration_type?: string;
  position_id?:number;
  instanceId?: string;
  hash?: string;
  lastConnectedAt?: Date | string;
  instanceData?: {
    profileName?: string;
    battery?: number;
  };
}

// ==================== CREATE CONNECTION ====================
export interface CreateConnectionDto {
  owner: string;
  company_id: number;
}

// ==================== ADD RECEIVER ====================
export interface AddReceiverDto {
  phoneNumber: string;
  name?: string;
  position_id?: number;
}

// ==================== ADD GROUP ====================
export interface AddGroupDto {
  groupId: string;
  groupName?: string;
  position_id?:number;
  purpose?: 'operational' | 'technical_reports';
}

// ==================== SEND MESSAGE ====================
export interface SendMessageDto {
  phoneNumber: string;
  message: string;
}

// ==================== SEND MEDIA ====================
export interface SendMediaDto {
  phoneNumber: string;
  mediaUrl: string;
  mimetype?: string;
  caption?: string;
  type: 'image' | 'video';
}

// ==================== UPDATE CONNECTION ====================
export interface UpdateConnectionDto {
  status?: string;
  phoneNumber?: string;
  receivers?: string[];
  groupReceivers?: string[];
}

// ==================== RESPONSE DTOS ====================
export interface QRCodeResponse {
  qrCode: string;
  expiresIn?: number;
}

export interface StatusResponse {
  status: string;
  phoneNumber: string | null;
}

export interface MessageResponse {
  success: boolean;
  message: string;
  data?: any;
}



export interface ReceiverWithPosition {
  id: string;
  phoneNumber: string;
  name?: string;
  position_id: number | null;
  position_name?: string;
  is_active: boolean;
}

export interface GroupWithPosition {
  id: string;
  groupId: string;
  groupName?: string;
  position_id: number | null;
  position_name?: string;
  purpose?: 'operational' | 'technical_reports';
  is_active: boolean;
}

export interface PositionReceivers {
  position_id: number | null;
  position_name: string;
  receivers: ReceiverWithPosition[];
  groups: GroupWithPosition[];
}
